module.exports = __webpack_public_path__ + "img/delete.1f9a0b0b.svg";